import React, { useEffect, useState } from "react";
import { Card, Grid, Tab, Tabs, Chip } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useDispatch, useSelector } from "react-redux";
import { projectActions } from "store/project-slice";
import { handleAxiosError } from "app/services/app.error.handler";
import {
  fetchAllProjects,
  fetchAllMilestones,
} from "app/services/project.service";
import { ProjectDataGrid } from "./ProjectDataGrid";
import { MilestoneDataGrid } from "./MilestoneDataGrid";

export const ProjectClientView = () => {
  const dispatch = useDispatch();
  const [tabValue, setTabValue] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const projects = useSelector((state) => state.project.projects);
  const milestones = useSelector((state) => state.project.milestones);

  const loadData = () => {
    setIsLoading(true);
    Promise.all([
      fetchAllProjects().then((data) => dispatch(projectActions.setProjects(data))),
      fetchAllMilestones().then((data) => dispatch(projectActions.setMilestones(data))),
    ])
      .catch((error) => handleAxiosError(error))
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const activeProjects = projects.filter((p) => p.status !== "COMPLETED");
  const completedProjects = projects.filter((p) => p.status === "COMPLETED");
  const upcomingMilestones = milestones.filter((m) => m.status !== "COMPLETED");

  return (
    <MDBox py={3}>
      <Grid container spacing={3}>
        {/* Stats Cards */}
        <Grid item xs={12} md={6} lg={3}>
          <Card>
            <MDBox p={3} textAlign="center">
              <MDTypography variant="h6" color="info">Total Projects</MDTypography>
              <MDTypography variant="h3" fontWeight="bold">{projects.length}</MDTypography>
              <MDTypography variant="caption">Your Projects</MDTypography>
            </MDBox>
          </Card>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <Card>
            <MDBox p={3} textAlign="center">
              <MDTypography variant="h6" color="success">Active</MDTypography>
              <MDTypography variant="h3" fontWeight="bold">{activeProjects.length}</MDTypography>
              <MDTypography variant="caption">In Progress</MDTypography>
            </MDBox>
          </Card>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <Card>
            <MDBox p={3} textAlign="center">
              <MDTypography variant="h6" color="primary">Completed</MDTypography>
              <MDTypography variant="h3" fontWeight="bold">{completedProjects.length}</MDTypography>
              <MDTypography variant="caption">Finished</MDTypography>
            </MDBox>
          </Card>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <Card>
            <MDBox p={3} textAlign="center">
              <MDTypography variant="h6" color="warning">Milestones</MDTypography>
              <MDTypography variant="h3" fontWeight="bold">{upcomingMilestones.length}</MDTypography>
              <MDTypography variant="caption">Upcoming</MDTypography>
            </MDBox>
          </Card>
        </Grid>

        {/* Main Content with Tabs */}
        <Grid item xs={12}>
          <Card>
            <MDBox p={2}>
              <Tabs value={tabValue} onChange={(e, v) => setTabValue(v)}>
                <Tab label={<MDBox display="flex" alignItems="center" gap={1}>
                  Your Projects
                  {projects.length > 0 && <Chip size="small" label={projects.length} color="primary" />}
                </MDBox>} />
                <Tab label={<MDBox display="flex" alignItems="center" gap={1}>
                  Milestones
                  {upcomingMilestones.length > 0 && <Chip size="small" label={upcomingMilestones.length} color="info" />}
                </MDBox>} />
              </Tabs>
            </MDBox>
            {tabValue === 0 && (
              <ProjectDataGrid projects={projects} isLoading={isLoading} showActions={false} />
            )}
            {tabValue === 1 && (
              <MilestoneDataGrid milestones={milestones} isLoading={isLoading} showActions={false} />
            )}
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
};

